/** Injected by the server's static handler (`apps/server/src/static.mjs`); the two names must match. */
const NEON_AUTH_URL_META_SELECTOR = 'meta[name="mothership-neon-auth-url"]';

/**
 * The server's runtime URL wins over the build-time one: one image runs in every
 * environment, so a URL baked in at build time would be the wrong one.
 */
export function resolveNeonAuthUrl(
  page: Pick<ParentNode, 'querySelector'> | undefined,
  buildTimeUrl: string | undefined,
): string | undefined {
  const injected = page
    ?.querySelector(NEON_AUTH_URL_META_SELECTOR)
    ?.getAttribute('content')
    ?.trim();
  if (injected !== undefined && injected.length > 0) {
    return injected;
  }
  const buildTime = buildTimeUrl?.trim();
  return buildTime === undefined || buildTime.length === 0 ? undefined : buildTime;
}
